module.exports = __webpack_public_path__ + "img/casinoAdministration20231409.d251ce12.png";